export default __webpack_public_path__ + "static/media/game_up_big.3a972eac.png";